export const legalPages = {
  "zh-CN": {
    privacy: {
      title: "隐私政策",
      paragraphs: [
        "本网站为独立体育资讯与推广信息页面，不运营任何第三方平台服务。",
        "我们可能收集基础访问数据，例如 IP 地址、浏览器类型、设备类型、页面访问记录与 CTA 点击事件，用于改进页面体验与衡量推广效果。",
        "本网站可能使用 Cookie、网站分析工具及广告追踪工具。你可以通过浏览器设置管理或禁用 Cookie。",
        "本网站不直接收集银行卡号、支付密码等敏感金融信息。",
        "点击第三方合作平台链接后，你将进入由第三方独立运营的平台。第三方拥有独立的隐私政策，本网站不控制也不负责其数据处理方式。",
        "我们建议你在使用第三方平台前，查看该平台自己的隐私政策。",
      ],
    },
    terms: {
      title: "服务条款",
      paragraphs: [
        "本站提供体育、电竞及线上娱乐相关资讯与推广信息。",
        "本站不是任何第三方合作平台的运营商，也不代表其官方身份。",
        "页面信息仅供一般信息及推广参考，不构成任何建议或承诺。",
        "第三方服务的可用性、活动、条款、账户及资金操作均由第三方平台负责。",
        "用户使用第三方平台前，应自行阅读第三方服务条款。",
        "服务可能因国家、地区、年龄或当地法律法规不同而不可用。",
        "本站不保证第三方服务持续可用，也不承诺任何收益、盈利或结果。",
      ],
    },
    disclosure: {
      title: "联盟披露",
      paragraphs: [
        "本站可能包含联盟推广链接。",
        "当你通过部分链接进入合作平台并完成符合条件的行为时，本站可能获得推广佣金。",
        "用户点击这些链接本身不会额外增加任何费用。",
        "联盟关系可能影响页面所展示的合作平台，但不会改变第三方自己的服务条款。",
        "本站不是 M88 或其他任何第三方平台的官方网站，也不声称代表其官方身份。",
        "我们不会隐藏联盟推广关系，并尽可能在页面中清楚说明。",
      ],
    },
    responsible: {
      title: "负责任游戏",
      paragraphs: [
        "仅限达到所在地法定年龄的用户访问相关第三方服务。",
        "涉及真钱游戏或博彩的服务存在资金损失风险。",
        "不应把博彩视为赚钱方式或稳定收入来源。",
        "用户应根据自己的财务能力娱乐，并设定个人可承受的限度。",
        "不要借钱参与任何形式的博彩活动。",
        "如博彩行为影响你的生活、财务或情绪，应立即停止并寻求当地专业帮助。",
        "服务可用性取决于所在地区的法律法规。",
        "如需帮助，请查询你所在地的正规博彩问题援助机构或专业咨询服务。",
      ],
    },
  },
  "zh-TW": {
    privacy: {
      title: "隱私政策",
      paragraphs: [
        "本網站為獨立體育資訊與推廣資訊頁面，不運營任何第三方平台服務。",
        "我們可能收集基礎訪問數據，例如 IP 位址、瀏覽器類型、裝置類型、頁面訪問記錄與 CTA 點擊事件，用於改進頁面體驗與衡量推廣效果。",
        "本網站可能使用 Cookie、網站分析工具及廣告追蹤工具。你可以透過瀏覽器設定管理或停用 Cookie。",
        "本網站不直接收集銀行卡號、支付密碼等敏感金融資訊。",
        "點擊第三方合作平台連結後，你將進入由第三方獨立運營的平台。第三方擁有獨立的隱私政策，本網站不控制也不負責其資料處理方式。",
        "我們建議你在使用第三方平台前，查看該平台自己的隱私政策。",
      ],
    },
    terms: {
      title: "服務條款",
      paragraphs: [
        "本站提供體育、電競及線上娛樂相關資訊與推廣訊息。",
        "本站不是任何第三方合作平台的運營商，也不代表其官方身份。",
        "頁面資訊僅供一般資訊及推廣參考，不構成任何建議或承諾。",
        "第三方服務的可用性、活動、條款、帳戶及資金操作均由第三方平台負責。",
        "用戶使用第三方平台前，應自行閱讀第三方服務條款。",
        "服務可能因國家、地區、年齡或當地法律法規不同而不可用。",
        "本站不保證第三方服務持續可用，也不承諾任何收益、盈利或結果。",
      ],
    },
    disclosure: {
      title: "聯盟披露",
      paragraphs: [
        "本站可能包含聯盟推廣連結。",
        "當你透過部分連結進入合作平台並完成符合條件的行為時，本站可能獲得推廣佣金。",
        "用戶點擊這些連結本身不會額外增加任何費用。",
        "聯盟關係可能影響頁面所展示的合作平台，但不會改變第三方自己的服務條款。",
        "本站不是 M88 或其他任何第三方平台的官方網站，也不聲稱代表其官方身份。",
        "我們不會隱藏聯盟推廣關係，並盡可能在頁面中清楚說明。",
      ],
    },
    responsible: {
      title: "負責任遊戲",
      paragraphs: [
        "僅限達到所在地法定年齡的用戶訪問相關第三方服務。",
        "涉及真錢遊戲或博彩的服務存在資金損失風險。",
        "不應把博彩視為賺錢方式或穩定收入來源。",
        "用戶應根據自己的財務能力娛樂，並設定個人可承受的限度。",
        "不要借錢參與任何形式的博彩活動。",
        "如博彩行為影響你的生活、財務或情緒，應立即停止並尋求當地專業協助。",
        "服務可用性取決於所在地區的法律法規。",
        "如需協助，請查詢你所在地的正規博彩問題援助機構或專業諮詢服務。",
      ],
    },
  },
  en: {
    privacy: {
      title: "Privacy Policy",
      paragraphs: [
        "This website is an independent sports information and promotional page; it does not operate any third-party platform services.",
        "We may collect basic visit data such as IP address, browser type, device type, page visits and CTA click events to improve the page experience and measure promotion performance.",
        "This site may use cookies, analytics tools and advertising trackers. You can manage or disable cookies in your browser settings.",
        "We do not directly collect sensitive financial information such as bank card numbers or payment passwords.",
        "After clicking a third-party partner platform link, you will enter a platform operated independently by that third party. Third parties have their own privacy policies, and we do not control or take responsibility for how they process data.",
        "We recommend reviewing the third-party platform's own privacy policy before using its services.",
      ],
    },
    terms: {
      title: "Terms of Service",
      paragraphs: [
        "This site provides information and promotions related to sports, esports and online entertainment.",
        "This site is not the operator of any third-party partner platform and does not represent its official identity.",
        "Page content is for general informational and promotional reference only and does not constitute advice or commitment.",
        "The availability, promotions, terms, accounts and fund operations of third-party services are the responsibility of the third-party platforms.",
        "Please read the third-party platform's terms of service before using its services.",
        "Services may be unavailable depending on your country, region, age or local laws and regulations.",
        "We do not guarantee the continuous availability of third-party services and do not promise any income, profit or outcome.",
      ],
    },
    disclosure: {
      title: "Affiliate Disclosure",
      paragraphs: [
        "This site may contain affiliate promotion links.",
        "When you visit a partner platform through certain links and complete qualifying actions, this site may earn a referral commission.",
        "Clicking these links does not add any extra cost to you.",
        "Affiliate relationships may influence which partner platforms are shown on the page, but they do not change the third party's own terms of service.",
        "This site is not the official website of M88 or any other third-party platform, and does not claim to represent them.",
        "We do not hide affiliate relationships and aim to state them clearly on the page.",
      ],
    },
    responsible: {
      title: "Responsible Gaming",
      paragraphs: [
        "Only users who have reached the legal age in their jurisdiction may access related third-party services.",
        "Services involving real-money gaming or betting carry the risk of financial loss.",
        "Betting should never be treated as a way to make money or a stable source of income.",
        "Play within your financial means and set personal limits you can afford.",
        "Never borrow money to participate in any form of betting.",
        "If betting affects your life, finances or emotions, stop immediately and seek local professional help.",
        "Service availability depends on the laws and regulations of your region.",
        "If you need help, please look for a licensed problem-gambling support organization or professional counselling service in your area.",
      ],
    },
  },
  vi: {
    privacy: {
      title: "Chính Sách Bảo Mật",
      paragraphs: [
        "Trang web này là trang thông tin và quảng bá thể thao độc lập, không vận hành dịch vụ của bất kỳ nền tảng bên thứ ba nào.",
        "Chúng tôi có thể thu thập dữ liệu truy cập cơ bản như địa chỉ IP, loại trình duyệt, loại thiết bị, lượt xem trang và sự kiện nhấp CTA để cải thiện trải nghiệm và đo lường hiệu quả quảng bá.",
        "Trang web có thể sử dụng cookie, công cụ phân tích và công cụ theo dõi quảng cáo. Bạn có thể quản lý hoặc tắt cookie trong cài đặt trình duyệt.",
        "Chúng tôi không trực tiếp thu thập thông tin tài chính nhạy cảm như số thẻ ngân hàng hay mật khẩu thanh toán.",
        "Sau khi nhấp vào liên kết nền tảng đối tác, bạn sẽ vào nền tảng do bên thứ ba vận hành độc lập. Bên thứ ba có chính sách bảo mật riêng và chúng tôi không kiểm soát cách họ xử lý dữ liệu.",
        "Chúng tôi khuyên bạn đọc chính sách bảo mật của nền tảng bên thứ ba trước khi sử dụng dịch vụ.",
      ],
    },
    terms: {
      title: "Điều Khoản Dịch Vụ",
      paragraphs: [
        "Trang này cung cấp thông tin và quảng bá liên quan đến thể thao, esports và giải trí trực tuyến.",
        "Trang này không phải là đơn vị vận hành của bất kỳ nền tảng đối tác bên thứ ba nào và không đại diện cho danh nghĩa chính thức của họ.",
        "Nội dung trang chỉ mang tính tham khảo thông tin và quảng bá chung, không cấu thành lời khuyên hay cam kết.",
        "Tính khả dụng, khuyến mãi, điều khoản, tài khoản và giao dịch tiền của dịch vụ bên thứ ba do nền tảng bên thứ ba chịu trách nhiệm.",
        "Vui lòng đọc điều khoản dịch vụ của nền tảng bên thứ ba trước khi sử dụng.",
        "Dịch vụ có thể không khả dụng tùy theo quốc gia, khu vực, độ tuổi hoặc pháp luật địa phương.",
        "Chúng tôi không đảm bảo dịch vụ bên thứ ba luôn khả dụng và không cam kết bất kỳ thu nhập, lợi nhuận hay kết quả nào.",
      ],
    },
    disclosure: {
      title: "Tiết Lộ Tiếp Thị Liên Kết",
      paragraphs: [
        "Trang này có thể chứa các liên kết tiếp thị liên kết.",
        "Khi bạn truy cập nền tảng đối tác qua một số liên kết và hoàn thành hành động đủ điều kiện, trang này có thể nhận hoa hồng quảng bá.",
        "Việc nhấp vào các liên kết này không làm bạn tốn thêm bất kỳ chi phí nào.",
        "Quan hệ liên kết có thể ảnh hưởng đến các nền tảng đối tác được hiển thị trên trang, nhưng không thay đổi điều khoản dịch vụ của bên thứ ba.",
        "Trang này không phải website chính thức của M88 hay bất kỳ nền tảng bên thứ ba nào khác, và không tuyên bố đại diện cho họ.",
        "Chúng tôi không che giấu quan hệ tiếp thị liên kết và luôn nêu rõ trên trang.",
      ],
    },
    responsible: {
      title: "Chơi Có Trách Nhiệm",
      paragraphs: [
        "Chỉ người dùng đủ tuổi hợp pháp tại nơi cư trú mới được truy cập các dịch vụ bên thứ ba liên quan.",
        "Dịch vụ liên quan đến trò chơi tiền thật hoặc cá cược có rủi ro mất tiền.",
        "Không nên xem cá cược là cách kiếm tiền hay nguồn thu nhập ổn định.",
        "Hãy giải trí trong khả năng tài chính của bạn và đặt giới hạn phù hợp.",
        "Không vay tiền để tham gia bất kỳ hình thức cá cược nào.",
        "Nếu cá cược ảnh hưởng đến cuộc sống, tài chính hoặc cảm xúc của bạn, hãy dừng lại ngay và tìm sự giúp đỡ chuyên môn tại địa phương.",
        "Khả năng cung cấp dịch vụ phụ thuộc vào pháp luật của khu vực bạn sinh sống.",
        "Nếu cần hỗ trợ, hãy tìm các tổ chức hỗ trợ vấn đề cờ bạc hợp pháp hoặc dịch vụ tư vấn chuyên môn tại nơi bạn sinh sống.",
      ],
    },
  },
  th: {
    privacy: {
      title: "นโยบายความเป็นส่วนตัว",
      paragraphs: [
        "เว็บไซต์นี้เป็นเพจข้อมูลและโปรโมชันกีฬาอิสระ ไม่ได้ดำเนินการบริการของแพลตฟอร์มบุคคลที่สามใดๆ",
        "เราอาจเก็บข้อมูลการเข้าชมพื้นฐาน เช่น ที่อยู่ IP ประเภทเบราว์เซอร์ ประเภทอุปกรณ์ การเข้าชมหน้าเว็บ และเหตุการณ์การคลิก CTA เพื่อปรับปรุงประสบการณ์และวัดผลการโปรโมต",
        "เว็บไซต์นี้อาจใช้คุกกี้ เครื่องมือวิเคราะห์ และเครื่องมือติดตามโฆษณา คุณสามารถจัดการหรือปิดคุกกี้ได้ในการตั้งค่าเบราว์เซอร์",
        "เราไม่เก็บข้อมูลทางการเงินที่ละเอียดอ่อน เช่น หมายเลขบัตรธนาคารหรือรหัสผ่านการชำระเงิน",
        "เมื่อคลิกลิงก์แพลตฟอร์มพันธมิตร คุณจะเข้าสู่แพลตฟอร์มที่ดำเนินการโดยบุคคลที่สามอย่างอิสระ ซึ่งมีนโยบายความเป็นส่วนตัวของตนเอง และเราไม่ควบคุมวิธีการจัดการข้อมูลของพวกเขา",
        "โปรดอ่านนโยบายความเป็นส่วนตัวของแพลตฟอร์มบุคคลที่สามก่อนใช้บริการ",
      ],
    },
    terms: {
      title: "ข้อกำหนดการใช้งาน",
      paragraphs: [
        "เว็บไซต์นี้ให้ข้อมูลและโปรโมชันเกี่ยวกับกีฬา อีสปอร์ต และความบันเทิงออนไลน์",
        "เว็บไซต์นี้ไม่ใช่ผู้ดำเนินการของแพลตฟอร์มพันธมิตรบุคคลที่สาม และไม่ได้เป็นตัวแทนอย่างเป็นทางการ",
        "เนื้อหาในหน้านี้ใช้เพื่อข้อมูลทั่วไปและการโปรโมตเท่านั้น ไม่ถือเป็นคำแนะนำหรือข้อผูกมัด",
        "ความพร้อมใช้งาน โปรโมชัน ข้อกำหนด บัญชี และการดำเนินการเงินของบริการบุคคลที่สามเป็นความรับผิดชอบของแพลตฟอร์มนั้น",
        "โปรดอ่านข้อกำหนดการใช้งานของแพลตฟอร์มบุคคลที่สามก่อนใช้บริการ",
        "บริการอาจไม่พร้อมใช้งานขึ้นอยู่กับประเทศ ภูมิภาค อายุ หรือกฎหมายท้องถิ่นของคุณ",
        "เราไม่รับประกันว่าบริการบุคคลที่สามจะพร้อมใช้งานตลอดเวลา และไม่สัญญารายได้ กำไร หรือผลลัพธ์ใดๆ",
      ],
    },
    disclosure: {
      title: "การเปิดเผยลิงก์พันธมิตร",
      paragraphs: [
        "เว็บไซต์นี้อาจมีลิงก์โปรโมชันแบบพันธมิตร",
        "เมื่อคุณเข้าชมแพลตฟอร์มพันธมิตรผ่านลิงก์บางรายการและทำการกระทำที่เข้าเงื่อนไข เว็บไซต์นี้อาจได้รับค่าคอมมิชชัน",
        "การคลิกลิงก์เหล่านี้ไม่ทำให้คุณมีค่าใช้จ่ายเพิ่มเติม",
        "ความสัมพันธ์แบบพันธมิตรอาจมีผลต่อแพลตฟอร์มที่แสดงในหน้านี้ แต่ไม่เปลี่ยนแปลงข้อกำหนดการใช้งานของบุคคลที่สาม",
        "เว็บไซต์นี้ไม่ใช่เว็บไซต์อย่างเป็นทางการของ M88 หรือแพลตฟอร์มบุคคลที่สามอื่นใด และไม่ได้อ้างว่าเป็นตัวแทน",
        "เราไม่ปิดบังความสัมพันธ์แบบพันธมิตร และระบุไว้อย่างชัดเจนในหน้านี้",
      ],
    },
    responsible: {
      title: "การเล่นอย่างรับผิดชอบ",
      paragraphs: [
        "เฉพาะผู้ใช้ที่มีอายุถึงเกณฑ์กฎหมายในพื้นที่ของตนเท่านั้นที่เข้าถึงบริการบุคคลที่สามที่เกี่ยวข้อง",
        "บริการที่เกี่ยวข้องกับเกมเงินจริงหรือการเดิมพันมีความเสี่ยงสูญเสียเงิน",
        "ไม่ควรมองการเดิมพันเป็นวิธีหาเงินหรือรายได้ประจำ",
        "โปรดเล่นตามความสามารถทางการเงินของคุณและกำหนดขีดจำกัดที่เหมาะสม",
        "อย่ากู้ยืมเงินเพื่อเข้าร่วมการเดิมพันใดๆ",
        "หากการเดิมพันส่งผลกระทบต่อชีวิต การเงิน หรืออารมณ์ของคุณ ให้หยุดทันทีและขอความช่วยเหลือจากผู้เชี่ยวชาญในพื้นที่",
        "ความพร้อมใช้งานของบริการขึ้นอยู่กับกฎหมายของภูมิภาคที่คุณอาศัยอยู่",
        "หากต้องการความช่วยเหลือ โปรดค้นหาองค์กรช่วยเหลือปัญหาการพนันที่ถูกกฎหมายหรือบริการให้คำปรึกษาในพื้นที่ของคุณ",
      ],
    },
  },
  ms: {
    privacy: {
      title: "Dasar Privasi",
      paragraphs: [
        "Laman web ini adalah halaman maklumat dan promosi sukan bebas; ia tidak mengendalikan perkhidmatan mana-mana platform pihak ketiga.",
        "Kami mungkin mengumpul data lawatan asas seperti alamat IP, jenis pelayar, jenis peranti, lawatan halaman dan acara klik CTA untuk menambah baik pengalaman dan mengukur prestasi promosi.",
        "Laman ini mungkin menggunakan kuki, alat analitik dan alat penjejakan iklan. Anda boleh mengurus atau melumpuhkan kuki dalam tetapan pelayar anda.",
        "Kami tidak mengumpul maklumat kewangan sensitif seperti nombor kad bank atau kata laluan pembayaran.",
        "Selepas mengklik pautan platform rakan kongsi, anda akan memasuki platform yang dikendalikan secara bebas oleh pihak ketiga. Pihak ketiga mempunyai dasar privasi tersendiri dan kami tidak mengawal cara mereka memproses data.",
        "Kami mengesyorkan anda membaca dasar privasi platform pihak ketiga sebelum menggunakan perkhidmatannya.",
      ],
    },
    terms: {
      title: "Terma Perkhidmatan",
      paragraphs: [
        "Laman ini menyediakan maklumat dan promosi berkaitan sukan, esports dan hiburan dalam talian.",
        "Laman ini bukan pengendali mana-mana platform rakan kongsi pihak ketiga dan tidak mewakili identiti rasmi mereka.",
        "Kandungan halaman hanya untuk rujukan maklumat am dan promosi, dan bukan merupakan nasihat atau janji.",
        "Ketersediaan, promosi, terma, akaun dan operasi dana perkhidmatan pihak ketiga adalah tanggungjawab platform tersebut.",
        "Sila baca terma perkhidmatan platform pihak ketiga sebelum menggunakan perkhidmatannya.",
        "Perkhidmatan mungkin tidak tersedia bergantung pada negara, wilayah, umur atau undang-undang tempatan anda.",
        "Kami tidak menjamin perkhidmatan pihak ketiga sentiasa tersedia dan tidak menjanjikan sebarang pendapatan, keuntungan atau hasil.",
      ],
    },
    disclosure: {
      title: "Pendedahan Gabungan",
      paragraphs: [
        "Laman ini mungkin mengandungi pautan promosi gabungan.",
        "Apabila anda melawat platform rakan kongsi melalui pautan tertentu dan melengkapkan tindakan yang layak, laman ini mungkin menerima komisen rujukan.",
        "Mengklik pautan ini tidak menambah sebarang kos kepada anda.",
        "Hubungan gabungan mungkin mempengaruhi platform rakan kongsi yang dipaparkan pada halaman, tetapi tidak mengubah terma perkhidmatan pihak ketiga.",
        "Laman ini bukan laman web rasmi M88 atau mana-mana platform pihak ketiga lain, dan tidak mendakwa mewakili mereka.",
        "Kami tidak menyembunyikan hubungan gabungan dan menyatakannya dengan jelas pada halaman ini.",
      ],
    },
    responsible: {
      title: "Permainan Bertanggungjawab",
      paragraphs: [
        "Hanya pengguna yang mencapai umur sah di wilayah mereka boleh mengakses perkhidmatan pihak ketiga yang berkaitan.",
        "Perkhidmatan yang melibatkan permainan wang sebenar atau pertaruhan membawa risiko kerugian wang.",
        "Pertaruhan tidak boleh dianggap sebagai cara menjana wang atau sumber pendapatan stabil.",
        "Sila bermain mengikut kemampuan kewangan anda dan tetapkan had peribadi yang mampu ditanggung.",
        "Jangan meminjam wang untuk menyertai sebarang bentuk pertaruhan.",
        "Jika pertaruhan menjejaskan kehidupan, kewangan atau emosi anda, berhenti dengan segera dan dapatkan bantuan profesional tempatan.",
        "Ketersediaan perkhidmatan bergantung pada undang-undang wilayah tempat anda menetap.",
        "Jika anda memerlukan bantuan, sila cari organisasi sokongan masalah perjudian yang sah atau perkhidmatan kaunseling profesional di kawasan anda.",
      ],
    },
  },
};
